export const SENTRY_ERROR_REPORTING_STORAGE_KEY = "critter.sentryErrorReporting";

const SENTRY_ERROR_REPORTING_CHANGED_EVENT = "critter-sentry-error-reporting-changed";

export function isSentryErrorReportingEnabled(): boolean {
  try {
    return globalThis.localStorage?.getItem(SENTRY_ERROR_REPORTING_STORAGE_KEY) !== "false";
  } catch {
    return true;
  }
}

export function setSentryErrorReportingEnabled(enabled: boolean): void {
  try {
    if (enabled) {
      globalThis.localStorage?.removeItem(SENTRY_ERROR_REPORTING_STORAGE_KEY);
    } else {
      globalThis.localStorage?.setItem(SENTRY_ERROR_REPORTING_STORAGE_KEY, "false");
    }
  } catch {
    // Storage can be unavailable; callers still keep the in-memory state for this session.
  }

  try {
    globalThis.dispatchEvent(
      new CustomEvent(SENTRY_ERROR_REPORTING_CHANGED_EVENT, { detail: { enabled } })
    );
  } catch {
    // Non-browser contexts do not need change notifications.
  }
}

export function subscribeSentryErrorReportingPreference(
  listener: (enabled: boolean) => void
): () => void {
  const handlePreferenceChanged = (event: Event) => {
    const customEvent = event as CustomEvent<{ enabled?: boolean }>;
    listener(customEvent.detail?.enabled ?? isSentryErrorReportingEnabled());
  };
  const handleStorage = (event: StorageEvent) => {
    if (event.key === SENTRY_ERROR_REPORTING_STORAGE_KEY) {
      listener(isSentryErrorReportingEnabled());
    }
  };

  globalThis.addEventListener?.(SENTRY_ERROR_REPORTING_CHANGED_EVENT, handlePreferenceChanged);
  globalThis.addEventListener?.("storage", handleStorage);

  return () => {
    globalThis.removeEventListener?.(SENTRY_ERROR_REPORTING_CHANGED_EVENT, handlePreferenceChanged);
    globalThis.removeEventListener?.("storage", handleStorage);
  };
}
